import { InfoBarContainer } from "./infobar.styles";
import { useSnapshot } from "valtio";
import { Store } from "../../store/Store";
import { useState } from "react";
import { Button, Modal, Tabs } from "antd";
import { EPSG_INdexData, horizontalCRSList, verticalCRSList } from "../../common/EPSGIndexUtils";
import { ReactComponent as CloseIcon } from "../../assets/svgs/icons/close-icon.svg";
import InfoDetails from "./InfoDetails";

const CrsInfo = () => {
    const snap = useSnapshot(Store);
    const [showModal, setShowModal] = useState(false);
    const [hCRSData, setHCRSData] = useState<EPSG_INdexData | null>(null);
    const [vCRSData, setVCRSData] = useState<EPSG_INdexData | null>(null);


    const showProjectionInfo = () => {
        const projection = snap.activeProjection;
        const hCRS = projection?.getHorizontalCRS();
        const vCRS = projection?.getVerticalCRS();
        const hCRSData = horizontalCRSList.find((crs: EPSG_INdexData) => crs.code === hCRS);
        const vCRSData = verticalCRSList.find((crs: EPSG_INdexData) => crs.code === vCRS);
        setHCRSData(hCRSData);
        setVCRSData(vCRSData);
        setShowModal(true);
    };

    const handleCancel = () => {
        setShowModal(false);
    };


    const tabItems = [
        {
            label: <span>Active Projection</span>,
            key: "1",
            children: (
                <>
                    <div>
                        {
                            !hCRSData && !vCRSData && (
                                <div className="no_data_box">No Active Projection</div>
                            )
                        }
                        <div>
                            <div className="info_main_box info_inner_main_box">
                                {hCRSData && (

                                    <div className="info_inner_box">
                                        <h3>Horizontal</h3>
                                    </div>
                                )}
                                {vCRSData && (
                                    <div className="info_inner_box info_inner_main_box_right main_title">
                                        <h3>Vertical</h3>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="info_main_box">
                            {hCRSData && (
                                <>
                                    <div className="info_inner_box info_inner_left_box">
                                        <InfoDetails infoData={hCRSData} />
                                    </div>
                                </>
                            )
                            }
                            {
                                vCRSData && (
                                    <>
                                        <div className="info_inner_box info_inner_right_box">
                                            <div className="info_inner_box info_inner_main_box_right main_width_title">
                                                <h3>Vertical</h3>
                                            </div>
                                            <InfoDetails infoData={vCRSData} />
                                        </div>
                                    </>
                                )
                            }
                        </div>

                    </div>
                </>
            ),
        },
    ];

    return (
        <>
            <InfoBarContainer>
                <div className="bottom-right" onClick={showProjectionInfo}>
                    <div className="" >
                        Active Projection :{" "}
                        <span id="activeProjectionSpan" className="active-projection">{snap.activeProjection?.getCRS()} </span>
                    </div>
                </div>
                <Modal
                    centered
                    open={showModal}
                    onCancel={handleCancel}
                    className="batch_modal create_batch_modal quota_modal info_modal"
                    closeIcon={
                        <CloseIcon key="CloseIcon" color="#ffffff" onClick={handleCancel} />
                    }
                    footer={[
                        <div key="footer-buttons" className="left-footer-buttons">
                            <Button onClick={handleCancel} type="primary" className="ok_batch_button info_footer_btn">
                                Ok
                            </Button>
                        </div>
                    ]}
                    style={{
                        backgroundColor: "#36BDBE",
                        width: "100%", // Adjust the width as per your need
                        maxWidth: "100%", // Set maximum width if needed
                    }}
                >
                    <InfoBarContainer>
                        <div className="table-container">
                            <div className="custom-tab-container">
                                <Tabs
                                    defaultActiveKey="1"
                                    items={tabItems}
                                    key="1"
                                    className="custom-tabs"
                                ></Tabs>
                            </div>
                        </div>
                    </InfoBarContainer>
                </Modal>
            </InfoBarContainer>
        </>
    );
};

export default CrsInfo;
